export const sendMessageRules = (inputs) => {
    return {
        sessionId: {
            errors: [],
            value: inputs.sessionId,
            isValid: null,
            validations: {
                required: "Session ID is required",
                maxLength: {
                    value: 100,
                    error: "Session ID cannot be more than 100 characters"
                }
            }
        },
        message: {
            errors: [],
            value: inputs.message,
            isValid: null,
            validations: {
                required: "Message is required",
                maxLength: {
                    value: 4000,
                    error: "Message cannot be more than 4000 characters"
                }
            }
        }
    }
} 